import type paper from "paper";

/** Set the CSS cursor on the Paper view's backing canvas element.
 *  Shared canvas helper; each tool sets its own cursor while active. */
export function setCanvasCursor(scope: paper.PaperScope, cursor: string) {
  const el = scope.view?.element as HTMLCanvasElement | undefined;
  if (el) el.style.cursor = cursor;
}
